module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-pagination"
  }, [_c('ul', {
    staticClass: "pagination",
    attrs: {
      "role": "navigation",
      "aria-label": "Pagination"
    }
  }, [_c('li', {
    staticClass: "pagination-previous",
    class: {
      disabled: _vm.currentPage === 1
    }
  }, [(_vm.currentPage !== 1) ? _c('a', {
    attrs: {
      "aria-label": "Previous page"
    },
    on: {
      "click": function($event) {
        return _vm.updatePage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("Previous"), _c('span', {
    staticClass: "show-for-sr"
  }, [_vm._v("page")])]) : _vm._e()]), _vm._l((_vm.pages), function(page, index) {
    return _c('li', {
      class: {
        current: page === _vm.currentPage, ellipsis: page === false
      }
    }, [(page !== false) ? _c('a', {
      attrs: {
        "aria-label": "'page '+page"
      },
      on: {
        "click": function($event) {
          return _vm.updatePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))]) : _vm._e()])
  }), _c('li', {
    staticClass: "pagination-next",
    class: {
      disabled: _vm.currentPage === _vm.pageCount || !_vm.pageCount
    }
  }, [(_vm.currentPage !== _vm.pageCount && _vm.pageCount) ? _c('a', {
    attrs: {
      "aria-label": "Next page"
    },
    on: {
      "click": function($event) {
        return _vm.updatePage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("Next"), _c('span', {
    staticClass: "show-for-sr"
  }, [_vm._v("page")])]) : _vm._e()])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-077649b6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Pagination.vue
// module id = 2238
// module chunks = 1